<ng-container *ngTemplateOutlet="editorContainer"></ng-container>

<span
  ngxTippy="Fullscreen Editor"
  id="{{ editorID }}_custom-button"
  class="d-none border-start border-dark-subtle ps-5 ql-formats"
>
  <button class="custom-button" (click)="onCustomButtonClick()">
    <i class="ki-duotone ki-arrow-two-diagonals fs-1">
      <i class="path1"></i>
      <i class="path2"></i>
      <i class="path3"></i>
      <i class="path4"></i>
      <i class="path5"></i>
    </i>
  </button>
</span>

<ng-template #editorContainer>
  <div
    class="position-relative custom-quill-editor h-100 d-flex flex-column {{
      !modalMode ? containerClass : ''
    }}"
  >

  
    <div
      class="editor-section position-relative h-100 w-100 d-flex flex-column"
    >
      <div
        id="{{ editorID }}"
        [class.d-none]="
          editorController?.aiStatus == 'loading' ||
          editorController?.aiStatus == 'finalizing' ||
          !this.editorController?.isInitialized
        "
      ></div>

      <div
      id="{{ editorID }}_writing_container"
      class="ql-container ql-snow flex-grow-1 h-200px"
      [ngClass]="{
        'overflow-y-hidden':
          editorController?.aiStatus == 'finalizing' ||
          (!this.editorController?.isEditorReady &&
            !!this.editorController?.isInitialized)
      }"
      *ngIf="
        editorController?.aiStatus == 'loading' ||
        editorController?.aiStatus == 'finalizing' ||
        !this.editorController?.isInitialized
      "
    >
      <div
      id="{{ editorID }}_writing"
        class="ql-editor text-start w-100 mx-auto"
        [innerHTML]="
          !!editorController?.aiGeneratedContent?.length
            ? editorController.aiGeneratedContent
            : content
        "
      ></div>
      <!-- 
  <div *ngIf="!this.editorController?.isEditorReady && !!this.editorController?.isInitialized" class="position-absolute w-100 h-100 z-index-2 left-0 top-0 bg-body d-flex flex-center">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div> -->
    </div>
    </div>

 

    <div
    *ngIf="
      (!hideBuiltInAiButton && !!promptFunction) &&
      editorController?.aiStatus != 'loading' &&
      editorController?.aiStatus != 'finalizing'
    "
    class="position-absolute opacity-75 opacity-100-hover"
    style="right: 20px; bottom: 13px; z-index: 2"
  >
    <app-dynamic-ai-button
      (buttonClick)="startGenerating()"
      buttonLabel="Use Now"
      ngxTippy="<div class='pt-3 fs-3 fw-bolder'>Use Our Ai</div> <hr> <p class='text-danger'><strong>Caution:</strong> When using AI-generated content, as they may lead to the loss of the current content.</p>"
      [buttonSettings]="{ colorSet: 'light-primary' }"
      size="lg"
      [iconButton]="true"
    ></app-dynamic-ai-button>
  </div>

  
  </div>
</ng-template>



<ng-template #modalContainer let-modal class="mymodalclass">
  <div class="modal-header font-title border-0">
    <h3
      class="modal-title d-flex flex-row align-items-center gap-2 fw-normal"
      id="modal-basic-title"
    >
      <i class="ki-duotone ki-tablet-text-down fs-1 text-primary">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
        <span class="path4"></span>
      </i>

      Outline Generator
    </h3>
  </div>
  <div class="modal-body pt-0">
    <span [ngTemplateOutlet]="editorContainer"></span>
  </div>
</ng-template>
<!-- {{htmlDebugContent}} -->
